import { Avatar, Box, ChakraProps, Image as ChakraImage } from '@chakra-ui/react';
import Image from 'next/image';
import { imageFormatter } from 'utils/imageFormatter';

export const ImageWrapper = ({
  imageFrontify,
  msImage,
  alt,
  imageSx = { w: '160px', h: '160px' },
  avatarSize = { base: 'xl', lg: '3xl' },
  imageSize = 205,
  sizes = '(max-width: 991px) 160px, 205px',
}: {
  imageFrontify?: string;
  msImage?: string;
  alt?: string;
  imageSx?: ChakraProps;
  avatarSize?: any;
  imageSize?: number;
  sizes?: string;
}) => {
  const imageData = imageFormatter(imageFrontify);
  const imageSource = imageFrontify
    ? `${imageData.src}${imageData.src.includes('?') ? '&' : '?'}width=${imageSize}&height=${imageSize}&format=webp`
    : imageData.src;
  return (
    <>
      {imageFrontify || msImage ? (
        <Box borderRadius='50%' overflow='hidden' mb='xs' order='1' {...imageSx}>
          {imageFrontify ? (
            <Image
              unoptimized
              width={imageSize}
              height={imageSize}
              src={imageSource}
              alt={imageData.alt}
              loading='lazy'
              sizes={sizes}
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          ) : (
            msImage && (
              <ChakraImage h='100%' w='100%' objectFit='cover' src={'data:image/png;base64,' + msImage} alt={alt} />
            )
          )}
        </Box>
      ) : (
        <Avatar name={alt} size={avatarSize} src={alt} alignSelf={{ base: 'center', md: 'start' }} {...imageSx} />
      )}
    </>
  );
};
